var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPooltogether(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    alt: "Logo for Pool Together",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pool Together") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 102,
    rx: 32,
    fill: "#E8D9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0302 40.9191C33.4599 40.9191 37.051 44.4047 37.051 48.7044V53.1811C37.051 57.4807 33.4599 60.9663 29.0302 60.9663C28.3344 60.9663 27.6593 60.8804 27.0156 60.7187V61.2471C27.0156 64.3926 24.3759 66.9484 21.0996 66.9993L21 67V49.8722L21.0092 49.872L21.0095 48.7044C21.0095 44.4047 24.6005 40.9191 29.0302 40.9191ZM64.949 40.9191C69.3813 40.9191 72.9745 44.4246 72.9745 48.749V53.2512C72.9745 57.5754 69.3813 61.0809 64.949 61.0809C60.5167 61.0809 56.9236 57.5754 56.9236 53.2512V48.749C56.9236 44.4246 60.5167 40.9191 64.949 40.9191ZM46.9873 40.5491C51.4196 40.5491 55.0127 44.0547 55.0127 48.379V52.8812C55.0127 57.2054 51.4196 60.7111 46.9873 60.7111C42.555 60.7111 38.9619 57.2054 38.9619 52.8812V48.379C38.9619 44.0547 42.555 40.5491 46.9873 40.5491ZM81 35V54.8634C81 58.0607 78.3168 60.6586 74.9864 60.7102L74.8854 60.7111V40.8476C74.8854 37.6181 77.623 35 81 35ZM64.949 46.7915C63.841 46.7915 62.9426 47.6679 62.9426 48.749V53.2512C62.9426 54.3322 63.841 55.2085 64.949 55.2085C66.0571 55.2085 66.9555 54.3322 66.9555 53.2512V48.749C66.9555 47.6679 66.0571 46.7915 64.949 46.7915ZM29.0302 46.7581C27.9228 46.7581 27.025 47.6294 27.025 48.7044V53.1811C27.025 54.2559 27.9228 55.1273 29.0302 55.1273C30.1376 55.1273 31.0354 54.2559 31.0354 53.1811V48.7044C31.0354 47.6294 30.1376 46.7581 29.0302 46.7581ZM46.9873 46.4215C45.8792 46.4215 44.9809 47.2979 44.9809 48.379V52.8812C44.9809 53.9622 45.8792 54.8387 46.9873 54.8387C48.0953 54.8387 48.9936 53.9622 48.9936 52.8812V48.379C48.9936 47.2979 48.0953 46.4215 46.9873 46.4215Z",
    fill: "url(#paint0_linear_3300_8580)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3300_8580",
    x1: 51,
    y1: 35,
    x2: 51,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E46F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46279A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPooltogether);
export default __webpack_public_path__ + "static/media/pooltogether.c12fc873f5fca9b5cc9969b38b5bdf15.svg";
export { ForwardRef as ReactComponent };